import React from 'react'
import { OverlayScrollbarsComponent } from "overlayscrollbars-react"
import './styles.scss'
import { MainProps } from './types'
import { useAppSelector } from '@redux/hooks'
import { firstLetterToUpperCase } from '@utils/format'
import createClassName from '@utils/createClassName'

const Main: React.FC <React.PropsWithChildren<MainProps>> = ({ children, name }) => {

    const { sidebarOpen } = useAppSelector(s => s.app)

    const mainClasses = createClassName('', [sidebarOpen && 'sidebar-open'])

    return(

        <OverlayScrollbarsComponent element = "main" defer>
            <main id = {`main${firstLetterToUpperCase(name)}`} className = {mainClasses}>
                <div id = "mainContainer">{children}</div>
            </main>
        </OverlayScrollbarsComponent>

    )

}

export default Main